import api from 'services/api';
import { enforce, runSchema } from 'validation';
import { folderSchema, type Folder } from 'redux/slices/lists/foldersSlice';

/**
 * Fetch a single folder by id (nap-backend `GET /folders/:folder_id`). Used by
 * `showEditFolder` when the folder isn't in the list slice — e.g. the edit was
 * launched from the Workspace, which never populates that slice.
 *
 * Boundary-validated against the same `folderSchema` as the list rows (issue
 * #757 step 3): the returned `Folder` is fully typed with no `as`/`any`. A
 * structural failure or a drifted identity (`folder_id`/`zone_id`) yields null
 * so the caller surfaces a "not found" rather than opening the modal on a
 * degraded record.
 */
export const getFolder = async (id: number): Promise<Folder | null> => {
  try {
    const res = await api.get(`/folders/${id}`);
    const result = runSchema(folderSchema, res.data, 'getFolder');
    if (!result.ok) return null;
    return enforce(result.value, result.warnings, ['folder_id', 'zone_id']);
  } catch {
    return null;
  }
};
